<main>
  <ng-content></ng-content>
</main>
